export type DossierRegisterView = 'list' | 'kanban';

export function parseDossierRegisterView(
  pathname: string,
): DossierRegisterView | null {
  if (pathname === '/dossiers/kanban' || pathname.startsWith('/dossiers/kanban/')) {
    return 'kanban';
  }
  if (pathname === '/dossiers') return 'list';
  return null;
}

export function dossierRegisterPath(view: DossierRegisterView): string {
  return view === 'kanban' ? '/dossiers/kanban' : '/dossiers';
}
